export const wrapGlobalVariables = (globalVariables) => {
  for (const key in globalVariables) {
    if (global[key] !== undefined) {
      global[`temp__${key}`] = global[key];
    }
    global[key] = globalVariables[key];
  }
};

export const unwrapGlobalVariables = (globalVariables) => {
  for (const key in globalVariables) {
    if (global[`temp__${key}`] !== undefined) {
      global[key] = global[`temp__${key}`];
      delete global[`temp__${key}`];
    } else {
      delete global[key];
    }
  }
};
